import { FileText, PhoneCall, ShieldCheck, Wrench } from 'lucide-react'
import { getCar, brl } from '../data.js'

const meus = [
  {
    car: getCar('corolla-2018'),
    plano: '48x de R$ 1.690',
    pagas: 14,
    total: 48,
    inicio: 'Junho de 2025',
    status: 'Contrato ativo',
  },
]

export default function MeusCarros() {
  return (
    <main className="mx-auto max-w-4xl px-4 py-6 md:py-10">
      <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">Meus carros</h1>
      <p className="mt-1 text-slate-500">Olá, Carlos! Aqui está tudo sobre os seus contratos com a Sim.</p>

      {meus.map(({ car, plano, pagas, total, inicio, status }) => (
        <div key={car.id} className="mt-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm md:mt-8 md:flex">
          <img src={car.fotos[0]} alt={car.nome} className="h-48 w-full object-cover md:h-auto md:w-72" />
          <div className="flex-1 p-5 md:p-6">
            <div className="flex flex-wrap items-center gap-2">
              <div className="font-display text-xl font-bold text-slate-900">{car.nome}</div>
              <span className="rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold text-brand-700">{status}</span>
            </div>
            <div className="mt-1 text-sm text-slate-500">{car.ano} · Contrato desde {inicio} · {plano}</div>

            <div className="mt-4">
              <div className="flex justify-between text-xs text-slate-500">
                <span>{pagas} de {total} parcelas</span>
                <span>{Math.round((pagas / total) * 100)}% até o carro ser seu 🚗</span>
              </div>
              <div className="mt-1.5 h-2.5 overflow-hidden rounded-full bg-slate-100">
                <div className="h-full rounded-full bg-brand-600" style={{ width: `${(pagas / total) * 100}%` }} />
              </div>
            </div>

            <div className="mt-4 flex flex-wrap gap-2 text-xs text-slate-500">
              <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1.5"><ShieldCheck size={13} className="text-brand-600" /> Seguro ativo</span>
              <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1.5"><Wrench size={13} className="text-brand-600" /> Próxima revisão: 100.000 km</span>
            </div>

            <div className="mt-5 flex flex-wrap gap-3">
              <button
                onClick={() => alert('Protótipo: aqui abre o contrato assinado (PDF).')}
                className="inline-flex items-center gap-2 rounded-xl bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-700"
              >
                <FileText size={16} /> Ver contrato assinado
              </button>
            </div>
          </div>
        </div>
      ))}

      <div className="mt-6 flex flex-wrap items-center gap-3 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:gap-4 md:p-6">
        <div className="rounded-full bg-brand-50 p-3 text-brand-700"><PhoneCall size={22} /></div>
        <div>
          <div className="font-display font-bold text-slate-900">Precisa de algo? Fala com a gente.</div>
          <div className="text-sm text-slate-500">Manutenção, dúvidas do contrato, qualquer coisa:</div>
        </div>
        <a href="tel:+5511999990000" className="font-display ml-auto text-lg font-extrabold text-brand-700 md:text-xl">(11) 99999-0000</a>
      </div>
    </main>
  )
}
